module.exports = __webpack_public_path__ + "media/images/div_lens/racial-bodytypes-96da7ed92628cbbf3952c1fb192c2178.png";